const items = ["A Label of Her Own", "Her Label", "Press-On Couture", "www.herlabel.in"];

export default function Marquee() {
  const row = [...items, ...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-[#26221F]/15 bg-[#F3E6E1] py-5"
      data-testid="marquee-strip"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex w-max items-center" aria-hidden={half === 1}>
            {row.map((text, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-2xl italic tracking-wide text-[#26221F] md:text-3xl">
                  {text}
                </span>
                <span className="mx-10 text-[#D8AFA4] text-xl md:mx-16">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
